import { GET_TOC } from './jigsaw-methods';
import { createSelector } from 'reselect';
import { getCurrentCfi } from './page-context-selectors';
import {
  findIndexMatchingCfiFallBackToBefore,
  findIndexMatchingDocAndCfiFallBackToBefore,
} from 'app/api/jigsaw-helpers';

const emptyArray = [];

export function getToc(state) {
  const data = state.jigsaw[GET_TOC].data;
  return data ? data.toc : emptyArray;
}

export function getActiveTocLabel(state) {
  const index = getActiveTocIndex(state);
  if (index >= 0) {
    return getToc(state)[index].title;
  }
  return null;
}

export const getActiveTocIndex = createSelector(
  state => getToc(state),
  state => getCurrentCfi(state),
  (toc, cfi) => {
    const docMatch = findIndexMatchingDocAndCfiFallBackToBefore(
      toc,
      el => el.cfi,
      cfi
    );
    if (docMatch >= 0) {
      return docMatch;
    }
    return findIndexMatchingCfiFallBackToBefore(toc, el => el.cfi, cfi);
  }
);



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/toc-selectors.js